{
    "schemaVersion": 1,
    "updaterPublicKey": "dW50cnVzdGVkIGNvbW1lbnQ6IG1pbmlzaWduIHB1YmxpYyBrZXk6IDMzMTUxQzdDMkNGNjZDM0UKUldRK2JQWXNmQndWTTh1ay80MGp0dE5ZVkNRdmNoQjMzUnJxVE5kQXZ6R3owekQ3a1Q3Z011eGEK",
    "releases": []
}
